export enum TrackerThresholdPercentages {
  Medium = 40,
  High = 70,
}
